import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Page } from '@dixa/lib-shared-habla';
import { useMount } from 'react-use';
import { IfFeatureFlagOn } from 'components/shared/featureFlag';
import { MessagingAppList } from './MessagingAppList';
import { MessagingEmpty } from './MessagingEmpty';
import { WhatsappAppList } from './WhatsappAppList';
import { TwitterSettings } from './components/twitterSettings';
import './messaging.less';
const MessagingList = (props) => {
    useMount(() => {
        const { messagingGetApps, whatsappGetApps, twitterGetAccounts, twitterGetOrganizationSettings, hasTwitter, } = props;
        messagingGetApps();
        whatsappGetApps();
        if (hasTwitter) {
            twitterGetAccounts();
            twitterGetOrganizationSettings();
        }
    });
    const hasConnectedApps = () => {
        return (hasConnectedFacebookApp() ||
            hasConnectedWhatsAppApp() ||
            hasConnectedInstagramAccounts() ||
            hasConnectedTwitterAccounts());
    };
    const showLoader = () => {
        const { asyncStatus, whatsappAsyncStatus, twitter, hasTwitter } = props;
        const hasLoadingChannel = asyncStatus === 'loading' ||
            whatsappAsyncStatus === 'loading' ||
            (hasTwitter && twitter.meta.asyncStatusReadAccounts === 'loading');
        return !hasConnectedApps() && hasLoadingChannel;
    };
    const showEmptyState = () => {
        const { asyncStatus, whatsappAsyncStatus } = props;
        const channelsLoaded = asyncStatus === 'succeeded' || whatsappAsyncStatus === 'succeeded';
        return !hasConnectedApps() && channelsLoaded;
    };
    const hasConnectedFacebookApp = () => {
        const { asyncStatus, apps } = props;
        const hasConnectedCustomFacebookApp = apps.some((app) => app.type === 'custom');
        const hasConnectedDixaFacebookAppWithPages = apps.some((app) => app.type === 'common' && app.pages.length > 0);
        return (asyncStatus === 'succeeded' &&
            (hasConnectedCustomFacebookApp || hasConnectedDixaFacebookAppWithPages));
    };
    const hasConnectedInstagramAccounts = () => {
        const { asyncStatus, apps } = props;
        const hasConnectedInstagramAccount = apps.some((app) => app.instagram_accounts.length > 0);
        return asyncStatus === 'succeeded' && hasConnectedInstagramAccount;
    };
    const hasConnectedWhatsAppApp = () => {
        const { whatsappAsyncStatus, whatsappIntegrations } = props;
        return (whatsappAsyncStatus === 'succeeded' && whatsappIntegrations.length > 0);
    };
    const hasConnectedTwitterAccounts = () => {
        const { twitter, hasTwitter } = props;
        if (!hasTwitter)
            return false;
        return (twitter.meta.asyncStatusReadAccounts === 'succeeded' &&
            twitter.accounts.length > 0);
    };
    const getCardTitle = () => {
        return 'Third-party messaging';
    };
    const { apps, queues, messagingGetApps, whatsappIntegrations } = props;
    if (showLoader()) {
        return _jsx("div", { children: "Loading..." });
    }
    if (showEmptyState()) {
        return (_jsx(MessagingEmpty, { apps: apps, title: getCardTitle(), messagingGetApps: messagingGetApps }));
    }
    return (_jsxs(Page, Object.assign({ className: "content-panel messenger-settings" }, { children: [_jsx(Page.Head, { title: "Third-party messaging" }), _jsxs(Page.Body, Object.assign({ className: "content" }, { children: [_jsx(MessagingAppList, { deleteApp: props.messagingDeleteApp, updatePage: props.messagingUpdatePage, updateInstagramPage: props.messagingUpdateInstagramPage, deletePage: props.messagingDeletePage, deleteInstagramAccount: props.messagingDeleteInstagramAccount, messagingGetApps: messagingGetApps, apps: apps, queues: queues, updateAccessToken: props.updateAccessToken }), _jsx(IfFeatureFlagOn, Object.assign({ name: "twitter-channel" }, { children: _jsx(TwitterSettings, {}) })), _jsx(IfFeatureFlagOn, Object.assign({ name: "whatsapp-channel" }, { children: _jsx(WhatsappAppList, { integrations: whatsappIntegrations, updateIntegration: props.whatsappUpdateIntegration, deleteIntegration: props.whatsappDeleteIntegration, queues: queues }) }))] }))] })));
};
export default MessagingList;
